module.exports = {"libs.subscriptionActivate.message.required":"Required","libs.subscriptionActivate.message.invalidPassword":"Your password must be 8 characters long. Please update"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/en/libs/subscriptionActivate.json
// module id = 732
// module chunks = 0